export const STORAGE_KEYS = {
    ACCESS_TOKEN: 'auth'
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/storage.ts